import {
  pageMoveAnkerFunc,
} from "./common/_pageLinkAnimation";
import {
  idxFunc,
} from "./pages/_index";

import { animation } from "./pages/_animation";
//* ----------------------------------------
//window実行
//--------------------------------------- */
////// ロード時
$(window).on('load', function () {
  idxFunc();

});
animation();
pageMoveAnkerFunc()

